import { type UploadResponse  } from "components/ProviderProfile/interfaces";
import { BaseController } from "./baseController";
import { type UploadPayload } from "../types";

export interface FileUploadSearchParams {
    Type: 'provider' | 'activity';
    Id: number;
}

export class FileUploadController extends BaseController {
    constructor(apiHost: string, version = 'v1') {
        super(apiHost, version);
        this.setHeaders({
            'Content-Type': 'multipart/form-data',
        });
    }

    async searchFiles(params?: FileUploadSearchParams, version = this.version): Promise<UploadResponse[]> {
        return this.get<UploadResponse[], FileUploadSearchParams>(this.getEndpoint('search', version), params);
    }

    async getFileById(fileId: string, version = this.version): Promise<UploadResponse> {
        return this.get<UploadResponse>(this.getEndpoint(`file/${fileId}`, version));
    }

    async uploadFile(payload: UploadPayload, version = this.version): Promise<UploadResponse> {
        return this.post<UploadResponse, UploadPayload>(this.getEndpoint('upload', version), payload);
    }

    async updateFile(payload: UploadPayload, version = this.version): Promise<UploadResponse> {
        return this.patch<UploadResponse, UploadPayload>(this.getEndpoint(`upload/${payload.fileId}`, version), payload);
    }

    async deleteFile(fileId: string, version = this.version): Promise<void> {
        await this.delete<void>(this.getEndpoint(`file/${fileId}`, version));
    }
}
